import { IOption } from 'app/components/Select';

export const parsedOptionArray = <T>(array: T[] = [], keyLabel?: keyof T, keyValue?: keyof T) => {
	return (
		(array
			?.filter(item => item != null)
			.map(item => ({ label: item[keyLabel!] || item, value: item[keyValue!] || item })) as IOption[]) || []
	);
};
